import {Observable} from 'rxjs';
import {HttpClient, HttpRequest, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';

@Injectable()
export abstract class ImportDataService {

  constructor(public httpClient: HttpClient) {
  }

  checkImportValidity(file: File): Observable<any> {
    const url = this.getEndPointV1() + 'validate-upload';
    const formData = new FormData();
    formData.append('file', file, file.name);
    const uploadRequest = new HttpRequest('POST', url, formData, {reportProgress: true});
    return this.httpClient.request<void>(uploadRequest);
  }

  downloadTemplate(): Observable<HttpResponse<Blob>> {
    const url = this.getEndPointV1() + 'download-empty';
    return this.httpClient.get(url, {
      responseType: 'blob',
      observe: 'response'
    });
  }

  loadFile(file: File): Observable<any> {
    const url = this.getEndPointV1() + 'upload';
    const formData = new FormData();
    if (file) {
      formData.append('file', file, file.name);
      const uploadRequest = new HttpRequest('POST', url, formData, {reportProgress: true});
      return this.httpClient.request<void>(uploadRequest);
    }
    const uploadRequest = new HttpRequest('POST', url, formData, {reportProgress: true});
    return this.httpClient.request<void>(uploadRequest);
  }

  attachFile(id: number, file: File): Observable<any> {
    const url = this.getEndPointV1() + `${id}/attach`;
    const formData = new FormData();
    if (file) {
      formData.append('file', file, file.name);
      const uploadRequest = new HttpRequest('POST', url, formData, {reportProgress: true});
      return this.httpClient.request<void>(uploadRequest);
    }
    const uploadRequest = new HttpRequest('POST', url, formData, {reportProgress: true});
    return this.httpClient.request<void>(uploadRequest);
  }

  abstract getEndPointV1(): string;

}
